import { toast } from 'react-hot-toast';
import React, { useEffect, useState } from 'react';
import { RadioGroup, FormControl } from '@mui/material';

import {
  IInitialState,
  AccionDetalle,
  TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
import { Tr4inerContainedButton } from '../../Utils/Button';
import ToastDisplay from '../../Utils/ToastDisplay';
import FControlLabel from '../shared/Forms/FControlLabel';

interface IForm02 {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const Form02: React.FC<IForm02> = (props) => {
  const [openNextDialog, setOpenNextDialog] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const item = JSON.parse(localStorage.getItem('user')!);
    props.dispatch({
      type: TipoAccionDetalle.CHANGE_OBJETIVO,
      payload: item.objetivo,
    });
    props.dispatch({
      type: TipoAccionDetalle.CHANGE_NOMBRE,
      payload: item.nombres,
    });
    props.dispatch({
      type: TipoAccionDetalle.CHANGE_CORREO,
      payload: item.correo,
    });
    props.dispatch({
      type: TipoAccionDetalle.CHANGE_USUARIOTESTASESORIAID,
      payload: item.usuarioTestAsesoriaID,
    });
  }, []);

  const handleNext = () => {
    let error1 = false;
    if (props.state.tipoActividad === '') {
      error1 = true;
    }
    if (!error1) {
      window.scrollTo(0, 0);
      props.dispatch({
        type: TipoAccionDetalle.CHANGE_NFORM,
        payload: props.state.nForm + 1,
      });
    }
    if (error1) {
      if (error1) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Marca que tipo de actividad física tienes que tienes que cumplir.'}
          />,
        );
      }
      error1 = false;
    }
  };
  return (
    <>
      <div className="mb-3 container mt-5">
        <div className="container form-macro mb-4">
          <section id="form3">
            <div>
              <div className="text-center">
                <h2 style={{ fontWeight: '700' }}>¿Cuál es tu actividad física?</h2>
                <br />
              </div>
              <div className="row">
                <div className="col-12">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="1"
                      name="radio-buttons-group"
                      value={props.state.tipoActividad}
                      onChange={(e) => {
                        props.dispatch({
                          type: TipoAccionDetalle.CHANGE_TIPOACTIVIDAD,
                          payload: e.target.value,
                        });
                      }}
                      style={{ textAlign: 'left', marginBottom: '1rem' }}
                    >
                      <FControlLabel
                        value="1"
                        label={props.state.sexo === true ? 'Sedentario' : 'Sendetaria'}
                      />
                      <div className="select-detail">
                        Paso la mayor parte del tiempo sentado. No realizo ningún tipo de
                        actividad física.
                      </div>

                      <br />
                      <FControlLabel
                        value="2"
                        label={
                          props.state.sexo === true
                            ? 'Ligeramente activo'
                            : 'Ligeramente activa'
                        }
                      />
                      <div className="select-detail">
                        Realizo actividad física de 1 a 3 veces por semana, ya sea
                        entrenar en casa o gym, trotar, montar bicicleta, jugar fútbol,
                        etc.
                      </div>
                      <br />
                      <FControlLabel
                        value="3"
                        label={props.state.sexo === true ? 'Activo' : 'Activa'}
                      />
                      <div className="select-detail">
                        Realizo actividad física de 3 a 6 veces por semana, ya sea
                        entrenar en casa o gym, trotar, montar bicicleta, jugar fútbol,
                        etc.
                      </div>
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="row flex justify-content-center" style={{ width: '100%' }}>
          <div className="col-6 justify-content-center">
            <Tr4inerContainedButton
              variant="contained"
              size="large"
              sx={{
                textTransform: 'capitalize',
                fontWeight: 'bold',
                fontSize: '1.2rem',
              }}
              onClick={handleNext}
            >
              {`Siguiente`}
            </Tr4inerContainedButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form02;
